import { NavLink } from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';

export default function NavbarLink({ path, title, closeNavbar}) { 
    // If link is using a HashLink rather than a normal link.
    const LinkComponent = path.includes("#") ? NavHashLink : NavLink;

    return (
        <LinkComponent to={path} exact activeClassName={!path.includes("#") ? "active" : ""} className="custom-nav-link text-decoration-none mx-3" onClick={closeNavbar}>
            <span>{title}</span>
        </LinkComponent>
    );
}